import React from 'react';

import p1 from '../images/footers/p1.jpg';
import p2 from '../images/footers/p2.jpg';
import p3 from '../images/footers/p3.jpg';
import p4 from '../images/footers/p4.jpg';

import PageContext from './context';

import * as css from './footer-image.module.css';

const footers = {
    1 : p1,
    2 : p2,
    3 : p3,
    4 : p4
};

export default function FooterImage() {
    return (<PageContext.Consumer>
        {({ part }) => (<img className={css.footerImage} src={footers[part]} />)}
    </PageContext.Consumer>);
}
